import { ls } from "@/helpers/helpers";

export const authModule = {
  namespaced: true,
  state: {
    isAuthenticated: !!localStorage.getItem("accessToken"),
    token: localStorage.getItem("accessToken"),
  },
  getters: {
    getIsAuthenticated: function (state) {
      return state.isAuthenticated;
    },
    getToken: function (state) {
      return state.token;
    },
  },
  mutations: {
    setIsAuthenticated: function (state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
      state.token = payload.token;

      if (payload.isAuthenticated && payload.token) {
        localStorage.setItem("accessToken", payload.token);
      } else {
        localStorage.removeItem("accessToken");
      }
    },
    clearPersistedState: function () {
      ls.removeAll();
      ls.clear();
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("userData");
    },
  },
  actions: {
    setIsAuthenticated: function (context, payload) {
      context.commit("setIsAuthenticated", {
        isAuthenticated: payload.isAuthenticated,
        token: payload.token,
      });
    },
    clearPersistedState: function (context) {
      context.commit("clearPersistedState");
    },
  },
};